import React, { createContext } from 'react';
import { createActionCreators } from 'immer-reducer';
import { noop } from 'lodash-es';

import { Values } from 'components/commonTypes';

import { initialState, OnlineBookingReducer } from './reducer';
import type { State } from './types';

export const actions = createActionCreators(OnlineBookingReducer);

export interface StateContext {
  state: State;
  dispatch: React.Dispatch<ReturnType<Values<typeof actions>>>;
  actions: typeof actions;
}

export const OnlineBookingStateContext = createContext<StateContext>({
  state: initialState,
  dispatch: noop,
  actions,
});
